module.exports = __webpack_public_path__ + "img/ic_video.49c5970a.svg";